// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { handleLoginApi } from "./services/api";

// const LoginPage = () => {
//   const [password, setPassword] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate(); // Initialize useNavigate hook

//   const handleLogin = async () => {
//     try {
//       const response = await handleLoginApi(password);
//       setMessage(response.message);
//       if (response.message === "Login successful") {
//         // Store login status in localStorage
//         localStorage.setItem("isLoggedIn", "true");
//         // Navigate to /menu on successful login
//         navigate("/menu");
//       }
//     } catch (error) {
//       setMessage("Invalid Credentials");
//     }
//   };

//   // Function to handle Enter key press
//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleLogin();
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Login</h2>
//       <input
//         type="password"
//         placeholder="Enter your password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         onKeyDown={handleKeyPress} // Add onKeyDown event for Enter key
//         style={styles.input}
//       />
//       <button onClick={handleLogin} style={styles.button}>
//         LOGIN
//       </button>
//       {message && <p style={styles.message}>{message}</p>}
//     </div>
//   );
// };

// // Inline CSS styles
// const styles = {
//   container: {
//     width: "450px",
//     margin: "100px auto",
//     padding: "60px",
//     textAlign: "center",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
//     marginTop: "160px",
//   },
//   heading: {
//     marginBottom: "20px",
//     fontSize: "20px",
//   },
//   input: {
//     width: "100%",
//     padding: "10px",
//     marginBottom: "15px",
//     borderRadius: "5px",
//     border: "1px solid #ccc",
//     fontSize: "16px",
//   },
//   button: {
//     width: "100%",
//     padding: "10px",
//     border: "none",
//     borderRadius: "5px",
//     backgroundColor: "#007bff",
//     color: "white",
//     fontSize: "16px",
//     cursor: "pointer",
//   },
//   message: {
//     marginTop: "15px",
//     color: "red",
//   },
// };

// export default LoginPage;


//tagerprotect-login

import React, { useState } from "react";
import {
  TextField,
  Button,
  Card,
  Typography,
  Box,
  FormHelperText,
} from "@mui/material";
import { AccountCircle, Lock } from "@mui/icons-material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { handleLoginApi } from "./services/api";

const LoginContainer = styled(Box)(({ reverse }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundImage: "url('/tager.jpg')",
  backgroundSize: "cover",
  backgroundPosition: reverse ? "right center" : "left center",
}));

const LoginCard = styled(Card)({
  padding: "2rem",
  textAlign: "center",
  borderRadius: "12px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  width: "400px",
});

const AvatarContainer = styled(Box)({
  width: "100px",
  height: "100px",
  background: "#f1f5f9",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto 20px auto",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
});

const LoginPage = () => {
  const [reverse, setReverse] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // For error message
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await handleLoginApi(password);
      if (response.message === "Login successful") {
        localStorage.setItem("isLoggedIn", "true");
        navigate("/menu");
      } else {
        setError("Invalid Credentials"); // Show error message
      }
    } catch (error) {
      setError("Invalid Credentials"); // Show error message on API error
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <LoginContainer reverse={reverse}>
      <LoginCard>
        <AvatarContainer>
          <AccountCircle sx={{ fontSize: 60, color: "#334155" }} />
        </AvatarContainer>
        <Typography variant="h5" fontWeight={600} mb={2}>
          User Login
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          label="Password"
          type="password"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyPress}
          error={!!error} // Show red border if there's an error
          InputProps={{
            startAdornment: <Lock sx={{ marginRight: 1 }} />,
          }}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}{" "}
        {/* Error message below input */}
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ mt: 2, borderRadius: "25px", padding: "10px 0" }}
          onClick={handleLogin}>
          Login
        </Button>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;

